/**
 * Active Visit Hook
 * Persists the active visit state across navigation using localStorage.
 * One visit at a time — starts at check-in, cleared at checkout/success.
 */

const KEY = 'active_visit_v1';

export function getActiveVisit() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveActiveVisit(data) {
  localStorage.setItem(KEY, JSON.stringify(data));
}

export function clearActiveVisit() {
  localStorage.removeItem(KEY);
}